/**
 * Handle Osano modal links based on href anchors.
 *
 * #do-not-sell          -> Osano.cm.showDoNotSell()
 * #cookie-preferences   -> Osano.cm.showDrawer()
 *
 * @return {void}
 */
export function osanoLinks() {

	const actions = {
		'#do-not-sell': 'showDoNotSell',
		'#cookie-preferences': 'showDrawer'
	};

	document.addEventListener( 'click', ( event ) => {

		const link = event.target.closest( 'a[href^="#"]' );

		if ( !link ) {

			return;

		}

		const action = actions[link.getAttribute( 'href' )];

		if ( !action ) {

			return;

		}

		event.preventDefault();

		if (
			window.Osano &&
			window.Osano.cm &&
			typeof window.Osano.cm[action] === 'function'
		) {

			window.Osano.cm[action]();

		}

	} );

}
